import apiClient from '../../../api/apiClient';
import { MANAGER_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = MANAGER_REST_API_BASE_URL;

export const getAllItems = () => apiClient.get(`${REST_API_BASE_URL}/items`);

export const getItem = (id) => apiClient.get(`${REST_API_BASE_URL}/item/${id}`);

export const getAllItemsByParent = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/parent/${id}/items`);

export const getAllDocumentsByItem = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/item/${id}/documents`);

export const getAllAttachmentsByItem = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/item/${id}/attachments`);

export const addItemToParent = (parentid, itemid, item) =>
  apiClient.put(`${REST_API_BASE_URL}/parent/${parentid}/item/${itemid}`, item);

export const removeItemToParent = (parentid, itemid) =>
  apiClient.delete(`${REST_API_BASE_URL}/parent/${parentid}/item/${itemid}`);

export const addDocumentToItem = (itemid, documentid) =>
  apiClient.put(`${REST_API_BASE_URL}/item/${itemid}/document/${documentid}`);

export const removeDocumentToItem = (itemid, documentid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/item/${itemid}/document/${documentid}`,
  );

export const addAttachmentToItem = (itemid, attachmentid) =>
  apiClient.put(
    `${REST_API_BASE_URL}/item/${itemid}/attachment/${attachmentid}`,
  );

export const removeAttachmentToItem = (itemid, attachmentid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/item/${itemid}/attachment/${attachmentid}`,
  );

export const deleteItemAssignment = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/assignment/${id}`);

export const getAllAssignmentsByItem = (subid, itemid, role) =>
  apiClient.get(
    `${REST_API_BASE_URL}/subscription/${subid}/item/${itemid}/role/${role}/assignments`,
  );

export const addAssignmentByItem = (itemid, assignment) =>
  apiClient.post(
    `${REST_API_BASE_URL}/assignment-by-item/${itemid}`,
    assignment,
  );

export const getUsersByGroupAndRole = (role) =>
  apiClient.get(`${REST_API_BASE_URL}/group/users/role/${role}`);

export const getFile = (filename) =>
  apiClient.get(`${REST_API_BASE_URL}/file/${filename}`, {
    responseType: 'blob', // Receive response as Blob
    headers: {
      Accept: 'image/png, image/jpg, image/tiff, application/pdf', // Specify acceptable media types
    },
  });

export default apiClient;
